import { $enum } from 'ts-enum-util';
import { StringKeyOf } from 'ts-enum-util/dist/types/types';

export type EnumValue<T> = Record<StringKeyOf<T>, StringKeyOf<T>>;

export function parseEnumValue<T extends EnumValue<T>>(
  enumType: T,
  value: string
) {
  return $enum(enumType).asValueOrDefault(value);
}

export function parseEnumValueOrThrow<T extends EnumValue<T>>(
  enumType: T,
  value: string
) {
  return $enum(enumType).asValueOrThrow(value);
}

export function isEnumValue<T extends Record<string, string>>(
  enumType: T,
  value: unknown
): value is T[keyof T] {
  return typeof value === 'string' && $enum(enumType).isValue(value);
}

export function parseMaybeEnumValue<T extends EnumValue<T>>(
  enumType: T,
  value: string | null | undefined
) {
  return value ? parseEnumValue(enumType, value) : null;
}
